import { type SearchRecordsStep } from '../actionSectionTypes';

export const searchRecordsStepRemoveVariable = (
  step: SearchRecordsStep,
  variableName: string,
  errorIds: string[]
) => {
  const nextErrorIds: string[] = [];

  if (step.details.destinationVariable?.value === variableName) {
    const nextStep = {
      ...step,
      hasError: true,
      details: {
        ...step.details,
        destinationVariable: {
          ...step.details.destinationVariable,
          deleted: true,
        },
      },
    };
    if (!errorIds.includes(step.id) && !nextErrorIds.includes(step.id)) {
      nextErrorIds.push(step.id);
    }
    return {
      nextStep,
      nextErrorIds,
    };
  }

  return {
    nextStep: step,
    nextErrorIds,
  };
};
